<template>
    <div class="card canvas-element" :class="{locked: is_locked}">

        <div class="lock">
            <img src="/images/icons/lock.svg" alt="">
            Only available with a School Subscription
        </div>

        <a :href="url"
           @click.prevent="visit()">
            <img alt="" class="card-img" :src="preview_url_medium">
        </a>

        <div class="card-body">
            <a :href="url"
               @click.prevent="visit()"
               class="h5 mb-0 text-decoration-none">{{ element.name }}</a>
        </div>

        <modal v-if="modal.show"
               :id="utils.randomId({prefix: 'modal'})"
               :show="true"
               @close="closeModal"
               size="md">
            <template #title>
                Request Access
            </template>

            <p class="small">
                To view of this {{ type }}, give your email address and click <strong>Request Access</strong>.
            </p>

            <label for="access-email">Your Email</label>
            <input v-model="modal.data.email"
                   id="access-email"
                   type="email"
                   class="form-control"
                   placeholder="email@domain.com">

            <p class="mt-3 small">
                Nam nemo nostrum perspiciatis quaerat quam quos, recusandae, rerum sint voluptatibus.
            </p>

            <template #footer>
                <button class="btn btn-primary">Request Access</button>
            </template>
        </modal>

    </div>
</template>

<script>

import uploads from "@/mixins/uploads";
import utils from "@/mixins/utils";
import Modal from "@/Components/Common/Modal";

export default {
    name: "CanvasElementCard",
    components: {Modal},
    mixins: [uploads, utils],
    props: ['element'],

    data(){
        return {
            modal: {
                show: false,
                data: {
                    email: null,
                }
            }
        }
    },

    computed: {

        type(){
            return this.element.type;
        },

        groups(){
            return this.element.groups;
        },

        data(){
            return this.element.data;
        },

        preview_url_medium(){
            return this.preview_url ? this.uploads.image(this.preview_url, {w: 600, h: 400, c: false}) : 'https://via.placeholder.com/600x400?text=NO+PREVIEW';
        },

        preview_url(){
            switch (this.type){
                case 'activity':

                    if( typeof this.data?.preview_file !== 'undefined' ){
                        return (this.data?.preview_file?.preview_url) ? this.data?.preview_file?.preview_url : this.data?.preview_file?.url;
                    }
                    if( typeof this.data?.file !== 'undefined' ){
                        return (this.data?.file?.preview_url) ? this.data?.file?.preview_url : this.data?.file?.url;
                    }
                    break;

                case 'resource':
                    if( typeof this.data?.file !== 'undefined' ){
                        return (this.data?.file?.preview_url) ? this.data?.file?.preview_url : this.data?.file?.url;
                    }
                    break;
            }
            return null;
        },

        url(){
            return this.route(`public.${this.type}.show`, {canvas_element: this.element.id});
        },

        is_locked(){

            if( this.is_admin ) return false;

            const types = ['open'];
            if( this.is_student || this.is_teacher ) {
                types.push('free');
            }
            if( this.currentUserAccountTypeIs('paid') ){
                types.push('paid');
            }

            return this.groups.findIndex((g) => g.type === 'pay' && types.includes( g.name )) < 0;
        },

    },

    methods: {

        visit(){
            if( this.is_locked ){
                this.openModal()
            }else{
                this.$inertia.visit( this.url );
            }
        },

        openModal(){
            this.modal.data.email = '';
            this.modal.show = true;
        },

        closeModal(){
            this.modal.show = false;
        },
    },

}
</script>

<style lang="scss" scoped>
.card-img{
    width: 100%;
    height: 300px;
    object-fit: cover;
}
.canvas-element{
    &.locked{
        .lock{
            display: flex;
        }
    }
}

.lock{
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(white, .7);
    align-items: center;
    justify-content: center;
    pointer-events: none;

    img{
        width: 5rem;
        height: auto;
    }
}
</style>
